import StopInfoWindow from './styled';

export default StopInfoWindow;
